import type { ReactNode } from "react";

export interface InfoRow {
  label: string;
  value: ReactNode;
}

export default function InfoCard({
  title,
  rows,
  sub,
  footer,
}: {
  title: string;
  rows: InfoRow[];
  sub?: string;
  footer?: ReactNode;
}) {
  return (
    <div className="rounded-[10px] border border-line bg-white p-5 shadow-card">
      <h3 className="text-lg font-semibold text-ink">{title}</h3>
      {sub && <p className="mt-0.5 text-[13px] text-ink-secondary">{sub}</p>}
      <dl className="mt-3 flex flex-col">
        {rows.map((row, i) => (
          <div
            key={i}
            className={`flex items-center justify-between gap-4 py-2.5 ${i > 0 ? "border-t border-[#F1F5F9]" : ""}`}
          >
            <dt className="shrink-0 text-[13px] text-ink-secondary">{row.label}</dt>
            <dd className="min-w-0 text-right text-sm font-medium text-ink">{row.value}</dd>
          </div>
        ))}
      </dl>
      {footer}
    </div>
  );
}